var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 39.166,
    height: 41.46,
    viewBox: "0 0 39.166 41.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.864,
    y1: 0.15,
    x2: 0.239,
    y2: 0.915,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f13632"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f29d49"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7481",
    "data-name": "Group 7481",
    transform: "translate(23972.457 162.76)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3066",
    "data-name": "Path 3066",
    d: "M471.53,41.93c.077.026.155.045.233.074h0a11.49,11.49,0,0,1,1.443.5,20.907,20.907,0,0,1,11.036,11.97c-.055-2.867-.126-5.741-.116-8.421h0V42.062",
    transform: "translate(-24417.775 -204.69)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3067",
    "data-name": "Path 3067",
    d: "M429.517,74.015V67.955l-.023-4.327a21.806,21.806,0,0,0-.723-5.131v-.036a.65.65,0,0,0-.042-.165c-.068-.249-.139-.491-.213-.73a20.891,20.891,0,0,0-11.249-12.593,11.7,11.7,0,0,0-1.443-.5h0A19.234,19.234,0,0,0,394.487,51.1a20.508,20.508,0,0,0-3.765,16.232l3.374-2.906a.3.3,0,1,1,.391.458L390.861,68c.119.536.255,1.069.417,1.592l3.29-2.825a.3.3,0,0,1,.394.459l-3.484,2.99c.181.536.384,1.069.607,1.589l2.983-2.561a.3.3,0,0,1,.394.455l-3.129,2.7a19.7,19.7,0,0,0,11.672,10.5,15.8,15.8,0,0,0,14.013-1.631,1.594,1.594,0,0,0,.946-1.514c-.042-1.476-.058-2.951-.071-4.427a3.087,3.087,0,0,1-1.269.274,3.138,3.138,0,0,1-2.79-1.715,10.118,10.118,0,0,1-7.617.807,10.849,10.849,0,0,1-8.14-8.421,10.843,10.843,0,0,1,3.323-11.12,10.267,10.267,0,0,1,11.517-2.134,10.436,10.436,0,0,1,6.871,9.438c.2,2.583.145,5.166.132,7.749V84.454l8.6-4.989Z",
    transform: "translate(-24362.809 -205.755)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_6242",
    "data-name": "Ellipse 6242",
    cx: 1.918,
    cy: 1.918,
    rx: 1.918,
    ry: 1.918,
    transform: "translate(-23947.1 -135.211)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/Logo_Icon.d66640a6d9555e3b778284699c47284a.svg";
export { ForwardRef as ReactComponent };